import { Button, Stack, Typography } from '@mui/material';

import { ConnectorStatus } from '../../../../common/enums/connectorStatus';
import { StationButtonPRops } from './types';

export const StationButton = ({
  chosenConnector,
  onClick,
  error,
  disabled,
  text,
}: StationButtonPRops) => {
  if (!chosenConnector || chosenConnector?.status === ConnectorStatus.Charging)
    return null;

  return (
    <Stack
      textAlign="center"
      sx={{
        padding: { xs: '10px 0 20px' },
        position: 'relative',
        width: '100%',
      }}
    >
      <Button
        variant="contained"
        fullWidth
        onClick={onClick}
        disabled={disabled}
      >
        {text}
      </Button>
      {error ? (
        <Typography
          variant="caption"
          color="error"
          sx={{
            position: 'absolute',
            top: '80%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
          }}
        >
          {error}
        </Typography>
      ) : null}
    </Stack>
  );
};
